import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/components/layout/Providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ShellSync"] */ "/vercel/path0/app/components/layouts/ShellSync.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AppProviders"] */ "/vercel/path0/app/components/providers/AppProviders.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/script.js");
